'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import PricingPage from '@/components/pricing-page';
import { OnboardingPlatformTour } from '@/components/onboarding-platform-tour';
import { PLATFORM_TOUR_STEP_PRICING } from '@/lib/platform-tour-constants';

function PricingContent() {
  const searchParams = useSearchParams();
  const highlightEnterprise = searchParams.get('enterprise') === 'true';
  const scrollToComparison = searchParams.get('compare') === '1';

  return (
    <>
      {/* Final step of the cross-page platform tour. Fires when URL
          carries ?ptour=pricing. Ends by spotlighting the Pro plan card
          + "Try Pro free for 7 days" trial link — the conversion
          moment. After the tour completes the scene strips the query
          param; it doesn't trigger checkout itself, so the user still
          has full agency to click the actual trial link. */}
      <OnboardingPlatformTour expectedStep={PLATFORM_TOUR_STEP_PRICING} />
      <PricingPage highlightEnterprise={highlightEnterprise} stripeAccount="new" scrollToComparison={scrollToComparison} />
    </>
  );
}

export default function PricingPageRoute() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-zinc-950" />}>
      <PricingContent />
    </Suspense>
  );
}
